import React, { FC, useEffect } from 'react';

import { isBrowser } from '@lucid/utils';
import Cookies from 'js-cookie';
import { theme } from '@lucid/theme';
import { SiteNavbar } from '@lucid/components-react';

import {  NavbarProps } from 'components/navbar/navbar';
import useNavButtons, { placeholderButtons as initialPlaceholderButtons } from 'hooks/use-nav-buttons';
import { useMenuTopNavigation } from 'hooks/use-menu';

export interface ABNavbarProps extends NavbarProps {
  abTestTemplateSectionLink: string | null | undefined;
  isVariationB?: boolean;
  isVariationC?: boolean;
  isVariationD?: boolean;
}

const ABNavbar: FC<ABNavbarProps> = ({
  i18nData,
  isVisio = false,
  langPrefix,
  logo,
  nid,
  pageType,
  isVariationB = false,
  isVariationC = false,
  isVariationD = false,
  abTestTemplateSectionLink,
  shouldHideSignUpButton,
  ...rest
}) => {
  const navbarMenu = useMenuTopNavigation(langPrefix);
  let chartNavbarMenu = navbarMenu;

  if (isVariationB) {
    chartNavbarMenu = navbarMenu.filter(link => link.entityId !== '636');
    navbarMenu.map(link => {
      switch(link.entityId) {
        case '616':
          link.links = [];
          link.link = { url: { path: '/product' } };
          link.title = 'Product Overview';
          break;
        case '624':
          link.links = [];
          link.link = { url: { path: '/integrations' } };
          link.title = 'Integrations';
          break;
        case '652':
          link.link = { url: { path: abTestTemplateSectionLink || '/templates' } };
          link.title = 'Templates';
          break;
        case '644':
          link.title = 'Team Plans';
      }
    });
  } else if (isVariationC) {
    const removeNavLinks = ['616', '624', '636'];
    chartNavbarMenu = navbarMenu.filter(link => !removeNavLinks.includes(link.entityId!));
    navbarMenu.map(link => {
      if (link.entityId === '652') {
        link.link = { url: { path: abTestTemplateSectionLink || '/templates' } };
        link.title = 'Templates';
      }
    });
  } else if (isVariationD) {
    chartNavbarMenu = [];
  }

  useEffect(() => {
    if (isVariationC) {
      const templatesLink: HTMLElement | null = document.querySelector('.ab-test-652-selector');
      templatesLink!.style.marginRight = `${theme.space[3]}px`;
    }
  },[isVariationC]);

  const username = isBrowser()
    ? window.atob(Cookies.get('username') || '')
    : undefined;
  const initialNavButtons = useNavButtons(
    username,
    isVisio,
    shouldHideSignUpButton,
  );

  return (
    <SiteNavbar
      {...rest}
      i18nData={i18nData}
      initialNavButtons={initialNavButtons}
      initialPlaceholderButtons={initialPlaceholderButtons}
      logo={logo}
      menu={chartNavbarMenu}
    />
  );
};

export default ABNavbar;
